import TheGrid from '@/views/campaigns/ola/grid'
import Edit from '@/views/campaigns/ola/edit'
import TheImport from '@/views/campaigns/ola/import'

export default {
  path: '/campaigns/ola',
  redirect: '/campaigns/ola/index',
  name: 'ola',
  meta: {
    auth: {
      redirect: {
        name: 'ola.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Critérios'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'ola.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'ola.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'import',
    name: 'ola.import',
    component: TheImport,
    meta: {
      auth: true,
      label: 'Importar'
    }
  }, {
    path: 'edit/:id',
    name: 'ola.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
